import React, { useState } from "react";
import fetchData from "../../api/fetchApi";

export default function CreateSliderPage() {
  // Image upload handler
    const [form, setForm] = useState({
    name: "",
    image_path: "",
    image_path_dark: "",
    link: "",
    link_mobile: "",
    order: ""
  });
  const handleImageUpload = async (e, field = "image_path") => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    try {
      setLoading(true);
      setError(null);
      const res = await fetchData("chaat/files/uploads", "POST", formData, true);
      console.log("Upload response:", res.data[0].path);
     setForm(f => ({ ...f, [field]: res.data[0].path || "" }));
     
    } catch (err) {
      setError(err.message || "فشل رفع الصورة");
    } finally {
      setLoading(false);
    }
  };

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const body = { ...form, order: Number(form.order) };
      await fetchData("chaat/sliders", "POST", body);
      setSuccess("تمت إضافة السلايدر بنجاح!");
      setForm({ name: "", image_path: "", image_path_dark: "", link: "", link_mobile: "", order: "" });
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء الإضافة");
    } finally {
      setLoading(false);
    }
  };

return (
    <div className="mx-auto p-6 bg-white rounded-2xl shadow">
        <h2 className="text-xl font-bold mb-4">إضافة سلايدر جديد</h2>
        <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input
                name="name"
                value={form.name}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
                placeholder="اسم السلايدر"
                required
            />
      <div>
        <input
          type="file"
          accept="image/*"
          onChange={e => handleImageUpload(e, "image_path")}
          className="mb-2"
        />
      
        <input
          name="image_path"
          value={form.image_path}
          onChange={handleChange}
          className="border rounded px-3 py-2 w-full"
          placeholder="رابط الصورة"
          required
        />
       
      </div>
      <div>
        <input
          type="file"
          accept="image/*"
          onChange={e => handleImageUpload(e, "image_path_dark")}
          className="mb-2"
        />
       
        <input
          name="image_path_dark"
          value={form.image_path_dark}
          onChange={handleChange}
          className="border rounded px-3 py-2 w-full"
          placeholder="رابط الصورة (الوضع الداكن)"
        />
      </div>
            <input
                name="link"
                value={form.link}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
                placeholder="رابط الموقع"
            />
            <input
                name="link_mobile"
                value={form.link_mobile}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
                placeholder="رابط الموبايل"
            />
            <input
                name="order"
                value={form.order}
                onChange={handleChange}
                className="border rounded px-3 py-2 w-full"
                placeholder="الترتيب"
                type="number"
                required
            />

            <div className="flex items-end justify-end gap-4 ">
                <button
                    type="submit"
                    className="bg-blue-600  text-white px-4 py-2 rounded-lg shadow"
                    disabled={loading}
                >
                    {loading ? "جاري الإضافة..." : "إضافة"}
                </button>
                <div className="flex-1">
                    {error && <div className="text-red-600 text-sm">{error}</div>}
                    {success && <div className="text-green-600 text-sm">{success}</div>}
                </div>
            </div>
        </form>
   
    </div>  
)}
